import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Header from '../../components/Header/';
import Sidebar from '../../components/Sidebar/';
import Breadcrumb from '../../components/Breadcrumb/';
import Aside from '../../components/Aside/';
import Footer from '../../components/Footer/';

import Dashboard from '../../views/Dashboard/';
import Settings from '../../views/Settings/';
import Charts from '../../views/Charts/';
import Widgets from '../../views/Widgets/';
import Buttons from '../../views/Components/Buttons/';
import Cards from '../../views/Components/Cards/';
import Forms from '../../views/Components/Forms/';
import Modals from '../../views/Components/Modals/';
import SocialButtons from '../../views/Components/SocialButtons/';
import Switches from '../../views/Components/Switches/';
import Tables from '../../views/Components/Tables/';
import Tabs from '../../views/Components/Tabs/';
import FontAwesome from '../../views/Icons/FontAwesome/';
import SimpleLineIcons from '../../views/Icons/SimpleLineIcons/';
import Campaigns from '../../views/Campaigns/';
import AdGroups from '../../views/AdGroups/';
import Ads from '../../views/Ads/';
import Keywords from '../../views/Keywords/';
import Extensions from '../../views/Extensions/';
import Placements from '../../views/Placements/';
import Pages from '../../views/Pages/';

const queryString = require('query-string');

const RouteWithMCID = ({ component: Component, ...rest }) => (
  <Route {...rest}
    render={renderProps => {
      const { match } = renderProps;
      const parsed = queryString.parse(renderProps.location.search);
      const { mcId } = parsed;
      const id = match.params.mcId || localStorage.getItem('mcId') || mcId;

      if (id) {
        return <Component {...renderProps} />;
      } else {
        return <Redirect to="/"/>
      }
    }} />
);

class Full extends Component {
  render() {
    return (
      <div className="app">
        <Header {...this.props} />
        <div className="app-body">
          <Sidebar {...this.props} />
          <main className="main" style={{backgroundColor: 'white'}}>
            <Breadcrumb />
            <div className="container-fluid">
              <Switch>
                <Route path="/dashboard" name="Dashboard" component={Dashboard} />
                <RouteWithMCID path="/settings" name="Settings" component={Settings} />
                <RouteWithMCID path="/campaigns" name="Campaigns" component={Campaigns} />
                <RouteWithMCID path="/adgroups" name="AdGroups" component={AdGroups} />
                <RouteWithMCID path="/ads" name="Ads" component={Ads} />
                <RouteWithMCID path="/keywords" name="Keywords" component={Keywords} />
                <RouteWithMCID path="/extensions" name="Extensions" component={Extensions} />
                <RouteWithMCID path="/placements" name="Placements" component={Placements} />
                <RouteWithMCID path="/pages" name="Pages" component={Pages} />
                <Route path="/components/buttons" name="Buttons" component={Buttons} />
                <Route path="/components/cards" name="Cards" component={Cards} />
                <Route path="/components/forms" name="Forms" component={Forms} />
                <Route path="/components/modals" name="Modals" component={Modals} />
                <Route path="/components/social-buttons" name="Social Buttons" component={SocialButtons} />
                <Route path="/components/switches" name="Swithces" component={Switches} />
                <Route path="/components/tables" name="Tables" component={Tables} />
                <Route path="/components/tabs" name="Tabs" component={Tabs} />
                <Route path="/icons/font-awesome" name="Font Awesome" component={FontAwesome} />
                <Route path="/icons/simple-line-icons" name="Simple Line Icons" component={SimpleLineIcons} />
                <Route path="/widgets" name="Widgets" component={Widgets} />
                <Route path="/charts" name="Charts" component={Charts} />
                <Redirect from="/" to="/dashboard" />
              </Switch>
            </div>
          </main>
          <Aside />
        </div>
        <Footer />
      </div>
    );
  }
}

export default Full;



// WEBPACK FOOTER //
// ./src/containers/Full/Full.js